import {useUpmPlant} from '@hconnect/upm'
import {Loading} from '@hm/fundamental'

import {EmptyComponent} from './EmptyComponent'
import {ShutdownDetail, StaticPartDetailDrawing} from './ShutdownDetail'

import {useShutdowns} from '@refra/modules/common/providers'
import {useStaticPartComponentDetailQuery} from '@refra/modules/refra-static-parts/hooks/queries'
import {useSelectedComponent} from '@refra/modules/refra-static-parts/providers'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const StaticPartDetailCardBody = () => {
  const {selectedComponent} = useSelectedComponent()
  const {selectedShutdown} = useShutdowns()
  const staticPartId = useUrlParam('staticPartId')
  const plantCode = useUrlParam('plantCode')
  const selectedKilnId = useUrlParam('selectedKilnId')
  const upmPlant = useUpmPlant({plantId: plantCode})

  const {data: selectedComponentDetail, isLoading: isStaticPartComponentLoading} =
    useStaticPartComponentDetailQuery({
      plantUpmId: upmPlant.upmId,
      kilnUpmId: selectedKilnId,
      staticPartId: staticPartId,
      componentId: selectedComponent?.id ?? 0,
      shutdownId: selectedShutdown?.id,
      enabled: selectedComponent !== undefined
    })

  if (isStaticPartComponentLoading) return <Loading size="large" />

  if (!selectedComponent || !selectedComponentDetail) return <EmptyComponent />

  if (!selectedShutdown && selectedComponent)
    return <StaticPartDetailDrawing selectedComponent={selectedComponentDetail} />

  return <ShutdownDetail selectedComponent={selectedComponentDetail} />
}
